import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { match as Match } from "react-router-dom";
import { withOneColLayout } from "../../../../../../utils";
import PageSubheader from "../../../../../../components/PageSubheader";
import Form from "../form";

interface Props {
  match: Match<{ id: string }>;
  intl: IntlShape;
  backURL: string;
}

const CreateIncidentReason = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.incident.reason.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-incident-reason-create"
        goBackURL={backURL}
      />

      <Form {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateIncidentReason));
